/**
 *
 * @module entry
 * @desc {SDK.Services.Identity} entry point.
 *
 */

import Adobe from './adobe/entry';
import Bam from './bam/entry';

/**
 *
 * @typedef SDK.Services.Identity
 * @type {Object}
 *
 * @property {Adobe} Adobe
 * @property {Bam} Bam
 *
 */

/**
 *
 * @type {SDK.Services.Identity}
 *
 */
export default {

    Adobe,
    Bam

};



// WEBPACK FOOTER //
// ./src/services/identity/entry.js